<template>
  <section class="pulse-card">
    <div v-if="title || subtitle || $slots.actions" class="pulse-card__header">
      <div class="pulse-card__heading">
        <h2 v-if="title" class="pulse-card__title">{{ title }}</h2>
        <p v-if="subtitle" class="pulse-card__subtitle">{{ subtitle }}</p>
      </div>
      <div v-if="$slots.actions" class="pulse-card__actions">
        <slot name="actions" />
      </div>
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  name: "PulseCard",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
  },
};
</script>
